import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { CEContext } from "../../types";
import { PropertyOption, PropertyTypes } from "@gspwidget/widget-devkit";
import { WidgetPropertyService } from "@gspwidget/widget-core";

@Component({
  selector: "ce-array",
  templateUrl: "./ce-array.component.html",
})
export class CeArrayComponent implements OnInit {
  prop: PropertyOption;
  valueArray: any[];
  @Input() set propAndValue(v: { prop: PropertyOption; value: any[] }) {
    this.prop = v.prop;
    if (!Array.isArray(v.value)) {
      this.valueArray = [];
      this.onChangeValue.emit(this.valueArray);
    } else {
      this.valueArray = v.value;
    }
  }
  @Input() context: CEContext;

  readonly PropertyTypes = PropertyTypes;

  constructor(
    private widgetProperty: WidgetPropertyService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {}
  /** 如果不加，ce item 实例会混乱，从 color picker 发现的。其他类型有待测试 */
  TrackByFn = (i, item) => item || i;

  @Output() onChangeValue = new EventEmitter();
  handleChangeValueItem(index: number, newValue) {
    this.valueArray[index] = newValue;
    this.onChangeValue.emit(this.valueArray.slice());
  }
  handleAddValueItem() {
    const newVal = this.widgetProperty.getPropertyDefaultValue(
      this.prop,
      true,
      this.valueArray.length
    );
    this.valueArray.push(newVal);
    this.onChangeValue.emit(this.valueArray.slice());
  }
  handleRemoveValueItem(index: number) {
    this.valueArray.splice(index, 1);
    this.onChangeValue.emit(this.valueArray.slice());
  }
  handleSortChange = () => {
    this.onChangeValue.emit(this.valueArray.slice());
  };
}
